export const DOMAIN = 'Redirector';
